// @flow
import * as React from 'react';

import Banner from 'components/banners/Banner.jsx';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import Text from 'components/Text.jsx';
import userAgent from 'lib/currentUserAgent';

type Props = {
  authorized: boolean,
  requestAuthorization: () => void,
};

export default class InternetExplorerBanner extends React.Component<Props, *> {
  componentDidMount() {
    if (userAgent.ie() <= 11) {
      this.props.requestAuthorization();
    }
  }

  render() {
    if (!this.props.authorized) {
      return null;
    }

    return (
      <Banner type="warning">
        <Glyph name="caution" size="large" />
        <Text>
          Remind is no longer supporting Internet Explorer. For the best experience, please{' '}
          <Link href={LinkConstants.SUPPORTED_BROWSERS} target="_blank">
            use a different browser
          </Link>{' '}
          or{' '}
          <Link href={LinkConstants.APP_DOWNLOAD} target="_blank">
            download the app
          </Link>
        </Text>
      </Banner>
    );
  }
}
